import React, { useEffect } from 'react';
import { getUserDashboards } from 'api/users';
import { useQuery } from '@tanstack/react-query';
import { useOutletContext } from 'react-router-dom';

import { useAuth } from 'services/authentication';
import Loader from 'components/Loader';
import DashboardList from 'components/DashboardList';

export const getUserDashboardsQuery = (userId) => ({
    queryKey: ['users', userId, 'dashboards'],
    queryFn: async () => getUserDashboards(userId),
});

export default function Dashboards() {
    const { setDashboardId, setDashboardName } = useOutletContext();

    useEffect(() => {
        setDashboardName(null);
        setDashboardId(null);
    }, []);

    const { user } = useAuth();
    const { data: dashboards, isLoading } = useQuery(getUserDashboardsQuery(user.id));

    if (isLoading) return <Loader />;

    return (
        <div className="dashboard-list" data-testid="route-dashboards-index">
            <DashboardList dashboards={dashboards} allowCreate={user.permissions.role === 'admin'}></DashboardList>
        </div>
    );
}
